import { SellingPoint } from '../../model/selling-point.model';

export const initialState = {
  isReady: false,
  sellingPoints: {} as any,
  connectedSellingPoint: sessionStorage.getItem('connectedSellingPoint')
    ? JSON.parse(sessionStorage.getItem('connectedSellingPoint'))
    : ({} as any),
  sellingPointInfoBank: new SellingPoint(),
  loading: false,
  updateLoading: false,
  updated: false,
};

export type SellingPointState = Readonly<typeof initialState>;
